export default __webpack_public_path__ + "static/media/locationUnavailable.93c8b624.png";